"use client";

import { ArrangementImage } from "./arrangement-image";
import type { ImageArrangementProps } from "./image-arrangement-types";

interface StaggeredImageArrangementProps
  extends Pick<
    ImageArrangementProps,
    "background" | "images" | "readMoreLabel" | "readMoreModalTitle"
  > {}

export function StaggeredImageArrangement(
  props: Readonly<StaggeredImageArrangementProps>
) {
  const leftColumnImages = props.images.filter((_, index) => index % 2 === 0);
  const rightColumnImages = props.images.filter((_, index) => index % 2 === 1);

  return (
    <div
      className="flex gap-2 md:gap-10"
      data-testid="image-arrangement-staggered-grid"
    >
      <div
        className="flex min-w-0 flex-1 flex-col gap-2 pt-[20%] md:gap-10"
        data-testid="image-arrangement-staggered-column-left"
      >
        {leftColumnImages.map((image, index) => (
          <div
            data-testid="image-arrangement-staggered-item"
            key={`${image.src}-left-${index}`}
          >
            <ArrangementImage
              background={props.background}
              image={image}
              readMoreLabel={props.readMoreLabel}
              readMoreModalTitle={props.readMoreModalTitle}
              sizes="50vw"
            />
          </div>
        ))}
      </div>

      <div
        className="flex min-w-0 flex-1 flex-col gap-2 md:gap-10"
        data-testid="image-arrangement-staggered-column-right"
      >
        {rightColumnImages.map((image, index) => (
          <div
            data-testid="image-arrangement-staggered-item"
            key={`${image.src}-right-${index}`}
          >
            <ArrangementImage
              background={props.background}
              image={image}
              readMoreLabel={props.readMoreLabel}
              readMoreModalTitle={props.readMoreModalTitle}
              sizes="50vw"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
